export const scheduleCallLoanPreferences = (
    setShowCalendly: (arg: boolean) => void,
    navigate: (arg: string) => void,
): void => {
    if (window.innerWidth >= 1024) {
        setShowCalendly(true);
        return;
    }

    navigate('/eligibility/loan-preferences/book-call/calendar');
};
